module.exports = __webpack_public_path__ + "static/run-workflow-5199e200b4b9546531444ff3e54849f6.png";